import { render, staticRenderFns } from "./rewardCardGroup.vue?vue&type=template&id=72d0a3b2&scoped=true&"
import script from "./rewardCardGroup.vue?vue&type=script&lang=js&"
export * from "./rewardCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0a3b2",
  null
  
)

export default component.exports